var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSponsors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 208.858,
    height: 162.667,
    viewBox: "0 0 208.858 162.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ebebeb;}.b{fill:#e6e6e6;}.c{fill:#f5f5f5;}.d{fill:#f0f0f0;}.e,.h,.l,.r{fill:#fff;}.e{opacity:0.5;}.f{fill:#fafafa;}.g{fill:#e0e0e0;}.i{fill:currentColor;}.j{fill:#7f3e3b;}.k{fill:#263238;}.l{opacity:0.4;}.m{opacity:0.2;}.n{fill:#630f0f;}.o{opacity:0.3;}.p{fill:#ffc3bd;}.q{fill:#ff5652;}.r{opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -38.14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 38.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 208.858,
    height: 0.104,
    transform: "translate(0 143.803)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13.835,
    height: 0.104,
    transform: "translate(137.378 147.119)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 17.185,
    height: 0.104,
    transform: "translate(166.994 147.174)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 8.016,
    height: 0.104,
    transform: "translate(149.024 149.901)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 21.583,
    height: 0.104,
    transform: "translate(72.682 149.112)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 14.365,
    height: 0.104,
    transform: "translate(54.6 149.112)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.566,
    height: 0.104,
    transform: "translate(26.437 147.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M121.248,173.13H40.591a2.385,2.385,0,0,1-2.381-2.385V57.364A2.385,2.385,0,0,1,40.591,55h80.657a2.385,2.385,0,0,1,2.385,2.385v113.36A2.385,2.385,0,0,1,121.248,173.13ZM40.591,55.084a2.281,2.281,0,0,0-2.277,2.281v113.38a2.281,2.281,0,0,0,2.277,2.281h80.657a2.285,2.285,0,0,0,2.281-2.281V57.364a2.285,2.285,0,0,0-2.281-2.281Z",
    transform: "translate(-22.249 -47.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M337.546,173.13H256.885a2.389,2.389,0,0,1-2.385-2.385V57.364A2.389,2.389,0,0,1,256.885,55h80.661a2.385,2.385,0,0,1,2.377,2.364v113.38A2.385,2.385,0,0,1,337.546,173.13ZM256.885,55.084a2.285,2.285,0,0,0-2.281,2.281v113.38a2.285,2.285,0,0,0,2.281,2.281h80.661a2.285,2.285,0,0,0,2.281-2.281V57.364a2.285,2.285,0,0,0-2.281-2.281Z",
    transform: "translate(-148.191 -47.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M80.846,208.439H65.67v-67.82l15.176-4.958Z",
    transform: "translate(-38.239 -94.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M111.176,231.084H96V179.508l15.176-4.958Z",
    transform: "translate(-55.899 -117.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M122.942,164.168H119.32V151.862l3.622-1.182Z",
    transform: "translate(-69.478 -103.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 58.184,
    height: 113.51,
    transform: "translate(75.214 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 17.08,
    height: 40.318,
    transform: "translate(75.214 73.196)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 58.184,
    height: 113.51,
    transform: "translate(136.15 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M417.678,189.211H405.33V107.6l12.348-4.962Z",
    transform: "translate(-236.017 -75.697)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M444.066,231.084H428.89V179.508l15.176-4.958Z",
    transform: "translate(-249.736 -117.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M335,248.612h30.351v-40.1L335,204.66Z",
    transform: "translate(-195.065 -135.102)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M458.363,164.168H456.55V151.862l1.813-1.182Z",
    transform: "translate(-265.842 -103.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M444.189,171.252H442.38V158.946l1.809-1.186Z",
    transform: "translate(-257.591 -107.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M50.283,229.22H57.2v33.7H45.78V233.723A4.5,4.5,0,0,1,50.283,229.22Z",
    transform: "translate(-26.657 -149.403)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 15.167,
    height: 32.515,
    transform: "translate(57.544 80.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M236.117,237.088,220.95,232.05v32.515h15.167Z",
    transform: "translate(-128.656 -151.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M249.867,237.088,234.7,232.05v32.515h15.167Z",
    transform: "translate(-136.662 -151.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M271.01,224.728l15.167-5.038v37.678H271.01Z",
    transform: "translate(-157.805 -143.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M89.055,151.65H73.42L105.647,38.14h15.635Z",
    transform: "translate(-42.751 -38.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M201.255,151.65H185.62L217.843,38.14h15.639Z",
    transform: "translate(-108.084 -38.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M248.105,151.65H232.47L264.7,38.14h15.635Z",
    transform: "translate(-135.364 -38.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M349.105,151.65H341.29L373.517,38.14h7.815Z",
    transform: "translate(-198.728 -38.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M110.84,275.389c4.511-24.194,16.4-35.548,26.517-41.329C127.666,243.225,121.074,274.933,110.84,275.389Z",
    transform: "translate(-64.54 -152.221)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M61.835,288.845c-3.342-18.237-11.374-25.372-18.175-28.4C50.222,266.179,55.026,289.993,61.835,288.845Z",
    transform: "translate(-25.423 -167.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M72.9,279.669c-1.287-26.233-11.278-37.749-20.263-43.28C60.794,245.688,63.125,280.025,72.9,279.669Z",
    transform: "translate(-30.651 -153.578)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M101.15,271.944c2.089-26.358,13.233-38.693,23.141-44.954C115.194,236.948,111.76,271.5,101.15,271.944Z",
    transform: "translate(-58.898 -148.104)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M89,270.32c3.342-27.076-4.048-43.392-11.541-53.2C83.534,230.328,79.741,266.076,89,270.32Z",
    transform: "translate(-45.104 -142.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M130,297c8.434-15.773,19.014-19.532,27.151-19.917C148.542,280.071,137.009,300.514,130,297Z",
    transform: "translate(-75.697 -177.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M125.81,285.768c5.318-17.874,15.384-25.481,23.655-29C141.265,262.894,133.776,286.269,125.81,285.768Z",
    transform: "translate(-73.257 -165.445)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M98.923,266.844c9.089-28.033,4.983-45.318-.589-55.844C101.73,225.006,90.372,262.045,98.923,266.844Z",
    transform: "translate(-55.702 -138.794)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M66.55,320.56V338.2c0,4.507,8.133,8.2,18.079,8.2h0c9.942,0,18.079-3.688,18.079-8.2V320.56Z",
    transform: "translate(-38.751 -202.589)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M379.661,308.865c-1-16.638-8.162-24.445-14.591-28.4C370.935,286.747,372.706,308.56,379.661,308.865Z",
    transform: "translate(-212.575 -179.239)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M416.64,318.111c3.851-12.531,9.983-17.452,14.9-19.541C426.552,302.509,421.206,318.9,416.64,318.111Z",
    transform: "translate(-242.603 -189.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M406.07,311.818c3.145-18.037,10.982-25.957,17.615-29.758C417.319,288.447,412.724,312.056,406.07,311.818Z",
    transform: "translate(-236.448 -180.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M389.858,306.5c.835-18.129-5.723-26.608-11.968-30.911C383.262,282.445,382.627,306.2,389.858,306.5Z",
    transform: "translate(-220.04 -176.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M403,305.373c.046-18.618,6.521-29.837,12.5-36.583C410.206,277.875,409.7,302.454,403,305.373Z",
    transform: "translate(-234.661 -172.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M364.114,323.717c-4.424-10.861-11.345-13.434-16.884-13.7C352.865,312.075,359,326.135,364.114,323.717Z",
    transform: "translate(-202.187 -196.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M371.283,316c-2.089-12.293-8.333-17.511-13.693-19.942C362.674,300.271,365.786,316.344,371.283,316Z",
    transform: "translate(-208.219 -188.323)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M402.045,303c-3.805-19.278.5-31.162,5.226-38.4C403.737,274.224,408.3,299.692,402.045,303Z",
    transform: "translate(-233.255 -170.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M394.667,340v12.114c0,3.1-5.585,5.627-12.41,5.627h0c-6.825,0-12.406-2.531-12.406-5.627V340Z",
    transform: "translate(-215.358 -213.909)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.438 191.35)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 80.991,
    cy: 4.729,
    rx: 80.991,
    ry: 4.729
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.963 59.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M244.2,106.827V112.3a1.462,1.462,0,0,1-1.458,1.458H229.308a1.462,1.462,0,0,1-1.458-1.458V92.449A1.462,1.462,0,0,1,229.308,91h13.417a1.462,1.462,0,0,1,1.479,1.449v8.663",
    transform: "translate(-227.637 -90.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M242.428,113.691H229.011a1.671,1.671,0,0,1-1.671-1.671V92.141a1.671,1.671,0,0,1,1.671-1.671h13.417a1.671,1.671,0,0,1,1.671,1.671V100.8h-.443V92.141a1.253,1.253,0,0,0-1.253-1.253H229.011a1.253,1.253,0,0,0-1.253,1.253v19.854a1.253,1.253,0,0,0,1.253,1.253h13.417a1.253,1.253,0,0,0,1.253-1.253v-5.476h.443v5.476a1.671,1.671,0,0,1-1.7,1.7Z",
    transform: "translate(-227.34 -90.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M244.57,137.412a7.716,7.716,0,0,1,.856-.464,4.182,4.182,0,0,1,.418-.163,1.566,1.566,0,0,1,.493-.113l-.171-.1c-.029-.046-.046.071-.054.1l-.058.146a1.291,1.291,0,0,0-.1.326.259.259,0,0,0,.271.326,3.422,3.422,0,0,0,1.232-.48H247.3c.046,0,.1.063.146.079a.714.714,0,0,0,.213.042,3.181,3.181,0,0,1,.489,0c.255.025.251-.372,0-.393a2.387,2.387,0,0,1-.518,0c-.167-.038-.217-.155-.393-.075s-.317.184-.489.255a2.386,2.386,0,0,1-.242.088l-.159.046c-.046,0-.129,0-.063.067l.059.138c0-.267.284-.518.209-.794s-.418-.155-.622-.1a5.848,5.848,0,0,0-1.566.718.2.2,0,0,0,.2.343Z",
    transform: "translate(-237.194 -117.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 13.221,
    height: 0.439,
    transform: "translate(1.767 3.183)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 11.725,
    height: 0.439,
    transform: "translate(1.767 6.295)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 13.221,
    height: 0.439,
    transform: "translate(1.767 9.411)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 3.634,
    height: 0.439,
    transform: "translate(1.767 12.527)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 4.833,
    height: 0.439,
    transform: "translate(6.926 12.527)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 13.221,
    height: 0.439,
    transform: "translate(1.767 15.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M233.078,135.547a2.038,2.038,0,1,1,2.038-2.038A2.038,2.038,0,0,1,233.078,135.547Zm0-3.634a1.6,1.6,0,1,0,1.6,1.6,1.6,1.6,0,0,0-1.6-1.6Z",
    transform: "translate(-229.494 -114.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M235.446,134.679a1.2,1.2,0,1,1-1.2-1.2,1.2,1.2,0,0,1,1.2,1.2Z",
    transform: "translate(-230.659 -115.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M255.08,121.224a3.709,3.709,0,0,1,.593-1.6c.3-.455.664-.835,1-1.282q1.009-1.253,2.089-2.506c1.412-1.642,2.845-3.267,4.407-4.791a.226.226,0,0,1,.347.276c-1.128,1.867-2.385,3.634-3.663,5.384-.643.869-1.295,1.734-1.963,2.586-.338.418-.647.869-1.023,1.253a3.7,3.7,0,0,1-1.42.944.267.267,0,0,1-.334-.159A.28.28,0,0,1,255.08,121.224Z",
    transform: "translate(-243.493 -102.419)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 3.642,
    height: 0.439,
    transform: "translate(9.923 35.991) rotate(-41.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 5.309,
    height: 0.439,
    transform: "matrix(0.219, -0.976, 0.976, 0.219, 8.237, 35.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 0.439,
    height: 2.235,
    transform: "translate(4.99 34.159) rotate(-43.12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.364 55.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M311.5,396.819h-3.555l-.434-8.229h3.551Z",
    transform: "translate(-279.423 -259.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M353.066,396.819h-3.555l-1.391-8.229h3.551Z",
    transform: "translate(-303.069 -259.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M342.021,407.3h3.989a.292.292,0,0,1,.292.242l.551,3.158a.556.556,0,0,1-.551.635c-1.391-.025-2.064-.109-3.822-.109-1.078,0-3.989.113-5.48.113s-1.617-1.475-1-1.608a12.692,12.692,0,0,0,5.43-2.21A.906.906,0,0,1,342.021,407.3Z",
    transform: "translate(-295.809 -270.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M297.942,407.3h3.876a.292.292,0,0,1,.292.242l.551,3.158a.547.547,0,0,1-.543.635c-1.4-.025-3.417-.109-5.175-.109-2.055,0-2.577.113-4.992.113-1.458,0-1.792-1.475-1.174-1.608,2.807-.606,3.822-.672,6.291-2.151A1.712,1.712,0,0,1,297.942,407.3Z",
    transform: "translate(-269.508 -270.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M276.671,141.424,271.817,140s-4.946,11.75-6.621,12.531c-2.277,1.044-8.354,4.248-10.927,5.76a5.112,5.112,0,0,0,.1,2.632c4.215-.334,12.861-3.2,14.524-4.791C272.686,152.49,276.671,141.424,276.671,141.424Z",
    transform: "translate(-248.35 -115.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M293.912,132.151c1.378,3.074-8.087,16.558-8.087,16.558l-4.595-4.77s4.064-10.2,6.266-14.119C289.743,125.8,292.412,128.768,293.912,132.151Z",
    transform: "translate(-264.12 -108.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M293.912,132.151c1.378,3.074-8.087,16.558-8.087,16.558l-4.595-4.77s4.064-10.2,6.266-14.119C289.743,125.8,292.412,128.768,293.912,132.151Z",
    transform: "translate(-264.12 -108.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M278.968,165.28a4.716,4.716,0,0,0-1.044,1.855c-.138.56,3.1,4.879,4.353,4.7a4.59,4.59,0,0,0,2.953-2.059C285.489,169.119,279.574,164.925,278.968,165.28Z",
    transform: "translate(-262.193 -129.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M251.654,182.4l-2.924-.535.175,4.177s1.028.418,3.241-.952Z",
    transform: "translate(-245.196 -139.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M240.27,183.267l.535,2.569,3.154.234-.175-4.19Z",
    transform: "translate(-240.27 -139.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M307.51,388.6l.226,4.24h3.551l-.221-4.24Z",
    transform: "translate(-279.423 -259.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M351.675,388.6H348.12l.718,4.24h3.555Z",
    transform: "translate(-303.069 -259.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M296.986,126.518s-4.741,12.206-1.708,32.185h19c.267-2.924-.835-18.626,2.619-32.369a48.476,48.476,0,0,0-6.324-.806,70.39,70.39,0,0,0-8.079,0A36.665,36.665,0,0,0,296.986,126.518Z",
    transform: "translate(-271.71 -106.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M296.986,126.518s-4.741,12.206-1.708,32.185h19c.267-2.924-.835-18.626,2.619-32.369a48.476,48.476,0,0,0-6.324-.806,70.39,70.39,0,0,0-8.079,0A36.665,36.665,0,0,0,296.986,126.518Z",
    transform: "translate(-271.71 -106.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M337.979,132.824c-.418,2.264.029,7.673,1.888,13.927a91.453,91.453,0,0,1,2.089-15.953v-.025C340.694,130.644,338.384,130.7,337.979,132.824Z",
    transform: "translate(-297.08 -109.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M320.49,107.61c-.635,2.6-1.04,5.819.693,7.552,0,0-1.17,2.64-6,2.64-4.415,0-2.089-2.64-2.089-2.64,2.924-.689,2.953-4.273,2.544-6.295Z",
    transform: "translate(-282.319 -96.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M319,127.027c2.845.89,3.409,1.8,3.409,1.8s3.546-1.441,3.413-4.566a7.146,7.146,0,0,0-1.387-.8S324.134,125.774,319,127.027Z",
    transform: "translate(-286.113 -105.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M314.278,127.639a5.469,5.469,0,0,0-2.924,1.516s-1.015-1.065-.042-4.156c0,0,.948-.322,1.734-.489C313.024,124.514,312.385,126.97,314.278,127.639Z",
    transform: "translate(-281.391 -106.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M319.746,108.871a7.812,7.812,0,0,1-.226,4.265,4.779,4.779,0,0,0,1.316-.418,7.3,7.3,0,0,0,3.459-3.759c.084-.464.184-.915.292-1.349Z",
    transform: "translate(-286.416 -96.249)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M315.552,87.655c-1.136.372-3.676,2.552-1.253,3.651S317.532,87.012,315.552,87.655Z",
    transform: "translate(-282.786 -84.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M322.111,91.38c-1.107,3.409-1.583,5.43-3.759,6.851a4.5,4.5,0,0,1-6.963-4.018c.075-3.262,1.871-8.287,5.551-8.935A4.579,4.579,0,0,1,322.111,91.38Z",
    transform: "translate(-281.68 -83.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M318.573,84.864c-1.88.317-3.446.217-4.014-1.345s2.018-3.2,3.8-2.465c1.316-1.37,4.908-.317,5.372,1,2.089-.134,4.064,2.272,2.648,3.5a2.481,2.481,0,0,1,.418,3.889c.61,1.813-1.587,3.622-3.321,2.886-1.708-.51-2.64-.092-2.878-1.195a1.934,1.934,0,0,1,1.817-2.381A2.558,2.558,0,0,1,322,85.9,2.445,2.445,0,0,1,318.573,84.864Z",
    transform: "translate(-283.481 -80.412)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M318.322,107.628a2.531,2.531,0,0,0,1.85-.593.088.088,0,0,0,0-.121.079.079,0,0,0-.117,0,2.4,2.4,0,0,1-2.03.5.088.088,0,0,0-.1.067.075.075,0,0,0,.063.1A3.34,3.34,0,0,0,318.322,107.628Z",
    transform: "translate(-285.486 -95.829)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M332.655,107.5a3.5,3.5,0,0,1-2.506.723c-1.165-.13-1.253-1.278-.522-2.147.66-.785,2.064-1.671,3.037-1.094A1.491,1.491,0,0,1,332.655,107.5Z",
    transform: "translate(-292.028 -94.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M306.591,205.1s-.485,4.47-1.1,10.522c-.71,6.863-1.591,15.773-2.151,22.557v.092c-.109,1.291-.2,2.506-.284,3.6-.794,11.074.627,43.288.627,43.288h-6.023s-5.547-32.874-5.409-44.144c.129-10.831,1.85-35.923,1.85-35.923Z",
    transform: "translate(-270.534 -153.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M310.738,390.8c.029,0-.1,2.481-.1,2.481H303.7l-.175-2.724Z",
    transform: "translate(-277.1 -261.006)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M319,223.371c-.71,6.863-1.591,15.773-2.151,22.557v.092c-1.324-6.437-1.738-14.44-1.224-27.619Z",
    transform: "translate(-284.022 -160.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M312.82,205.11s2.774,25.673,4.5,35.844c1.892,11.14,9.361,44.219,9.361,44.219h6.508s-4.386-32.164-5.246-43.208c-.927-11.972-2.845-36.855-2.845-36.855Z",
    transform: "translate(-282.515 -153.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M351.388,391.121c.029,0,.226,2.331.226,2.331h-7.151l-.522-2.6Z",
    transform: "translate(-300.635 -261.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M321.981,98.816c-.075.28-.28.476-.459.418s-.267-.3-.2-.581.28-.476.459-.418S322.052,98.549,321.981,98.816Z",
    transform: "translate(-287.453 -90.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M314.5,97.176c-.075.28-.28.476-.46.418s-.267-.3-.2-.581.28-.476.46-.418S314.572,96.9,314.5,97.176Z",
    transform: "translate(-283.098 -89.829)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M316.232,98.86a11.1,11.1,0,0,1-1.942,2.118,1.574,1.574,0,0,0,1.253.539Z",
    transform: "translate(-283.371 -91.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M325.4,95.995a.171.171,0,0,1-.113-.1,1.253,1.253,0,0,0-.894-.777.159.159,0,0,1-.134-.192.175.175,0,0,1,.2-.142,1.562,1.562,0,0,1,1.145.969.18.18,0,0,1-.092.226.167.167,0,0,1-.109.013Z",
    transform: "translate(-289.177 -88.782)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M313.843,93.371a.25.25,0,0,1-.063-.038.167.167,0,0,1,0-.238,1.7,1.7,0,0,1,1.441-.585.159.159,0,0,1,.134.192.18.18,0,0,1-.2.142h0a1.366,1.366,0,0,0-1.14.476A.184.184,0,0,1,313.843,93.371Z",
    transform: "translate(-283.045 -87.453)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M347.236,139.23l-4.486,2.715s5.013,10.861,4.983,12.686c-.084,3.409,1.383,10.8.986,14.691a4.8,4.8,0,0,0,2.573-.029c.89-3.521,2.122-12.774,1.767-15.092C352.282,149.159,347.236,139.23,347.236,139.23Z",
    transform: "translate(-299.943 -114.661)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M341.235,127.529c3.342.489,8.1,17.448,8.1,17.448l-6.182,2.343s-5.384-9.19-6.7-13.321C335.032,129.688,337.655,127,341.235,127.529Z",
    transform: "translate(-296.047 -107.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M341.235,127.529c3.342.489,8.1,17.448,8.1,17.448l-6.182,2.343s-5.384-9.19-6.7-13.321C335.032,129.688,337.655,127,341.235,127.529Z",
    transform: "translate(-296.047 -107.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M346.836,407.535a1.007,1.007,0,0,1-.673-.184.472.472,0,0,1-.155-.443.284.284,0,0,1,.155-.238c.418-.2,1.516.5,1.642.585a.075.075,0,0,1,.033.084.092.092,0,0,1-.067.067A4.076,4.076,0,0,1,346.836,407.535Zm-.489-.748a.221.221,0,0,0-.109.021.109.109,0,0,0-.059.1.338.338,0,0,0,.1.309,1.684,1.684,0,0,0,1.253.063,3.2,3.2,0,0,0-1.186-.489Z",
    transform: "translate(-301.835 -270.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M348.83,406.266a.067.067,0,0,1-.038,0c-.359-.2-1.032-.977-.936-1.374a.288.288,0,0,1,.276-.217.455.455,0,0,1,.355.1c.4.338.418,1.366.418,1.408a.1.1,0,0,1-.042.079A.11.11,0,0,1,348.83,406.266Zm-.647-1.458h-.038c-.109,0-.121.063-.125.083-.058.234.368.835.718,1.1a1.9,1.9,0,0,0-.363-1.111A.288.288,0,0,0,348.183,404.808Z",
    transform: "translate(-302.911 -269.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M303.335,407.522a1.316,1.316,0,0,1-.856-.217.472.472,0,0,1-.138-.418.292.292,0,0,1,.15-.226c.443-.242,1.838.485,2,.568a.079.079,0,0,1,.038.088.088.088,0,0,1-.071.071A6.233,6.233,0,0,1,303.335,407.522Zm-.61-.748a.346.346,0,0,0-.159.029.121.121,0,0,0-.059.092.3.3,0,0,0,.092.272,2.262,2.262,0,0,0,1.583.1A4.447,4.447,0,0,0,302.725,406.774Z",
    transform: "translate(-276.409 -270.353)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M305.714,406.259h-.038c-.418-.192-1.253-.961-1.149-1.362,0-.1.1-.213.326-.234a.581.581,0,0,1,.46.142,2.454,2.454,0,0,1,.489,1.37.092.092,0,0,1-.042.075A.063.063,0,0,1,305.714,406.259Zm-.8-1.458h-.05c-.15,0-.163.075-.167.092-.05.242.5.835.923,1.107a1.913,1.913,0,0,0-.418-1.094A.418.418,0,0,0,304.912,404.8Z",
    transform: "translate(-277.681 -269.216)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 24.95,
    height: 17.477,
    rx: 4.09,
    transform: "translate(36.426 61.1) rotate(-7.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "o",
    width: 24.95,
    height: 17.477,
    rx: 4.09,
    transform: "translate(36.426 61.1) rotate(-7.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M351.905,221.074a1.608,1.608,0,0,1-.986-.338,1.637,1.637,0,0,1-.622-1.078l-.376-2.9a1.621,1.621,0,0,1,1.4-1.817l4.825-.631a1.625,1.625,0,0,1,1.821,1.4l.38,2.9a1.633,1.633,0,0,1-1.4,1.821h0l-4.829.627A1.823,1.823,0,0,1,351.905,221.074Zm4.453-5.848h-.088l-4.829.631a.677.677,0,0,0-.585.76l.376,2.9a.685.685,0,0,0,.263.451.672.672,0,0,0,.5.134l4.825-.627a.689.689,0,0,0,.589-.764l-.363-2.866a.677.677,0,0,0-.259-.451.689.689,0,0,0-.43-.155Zm.526,4.724Z",
    transform: "translate(-304.11 -158.371)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    width: 24.95,
    height: 17.477,
    rx: 4.09,
    transform: "translate(38.46 60.836) rotate(-7.43)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M355.622,208.828l-1.362,2.652,3.993.184a3.183,3.183,0,0,0-.518-3.584Z",
    transform: "translate(-306.645 -154.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M355.785,218.275l2.381-.326.088-1.546-3.993-.184.063.865a1.291,1.291,0,0,0,1.462,1.19Z",
    transform: "translate(-306.645 -159.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M350.812,170.045a4.722,4.722,0,0,0,.706,2c.326.468,5.714.881,6.408-.18a4.585,4.585,0,0,0,.393-3.58C357.988,167.656,350.941,169.339,350.812,170.045Z",
    transform: "translate(-304.633 -131.499)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.994 56.579)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M145.089,136.973c-.673.881-1.4,1.846-2.089,2.795s-1.345,1.913-1.976,2.891a37.344,37.344,0,0,0-3.262,5.936c-.1.246-.2.493-.284.739q-.067.184-.125.363l-.058.184-.025.088v.025a2.623,2.623,0,0,0-.046.977,16.1,16.1,0,0,0,.739,3.087c.714,2.16,1.671,4.386,2.611,6.546l-2.135,1.353a35.8,35.8,0,0,1-4.135-6.387,17.03,17.03,0,0,1-1.433-3.864,6.775,6.775,0,0,1-.1-2.648l.033-.2.033-.134.063-.259c.038-.171.079-.343.129-.51.092-.338.192-.664.3-.99a35.723,35.723,0,0,1,3.4-7.022c.668-1.082,1.353-2.143,2.089-3.166s1.462-2.018,2.31-3.037Z",
    transform: "translate(-124.255 -112.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M147.46,196.2l2.2,1.165-2.506,2.962a4,4,0,0,1-1.671-2.7Z",
    transform: "translate(-131.705 -148.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M154.915,200.815l-2.707,2.151-2.778-1.015,2.527-2.962Z",
    transform: "translate(-134.005 -150.239)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M239.52,181l2.6,1.341-.23.936-2.089,2.089a3.931,3.931,0,0,1-1.47-2.8Z",
    transform: "translate(-185.769 -139.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M242.08,181.257l2.381-.447,1.529.652-1.019.171-.668.606Z",
    transform: "translate(-187.954 -139.653)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M246.753,188.289l-2.581.556a1.253,1.253,0,0,1-.8-.1L241.82,188l2.089-2.089,1.383-.418,1.729,1.984a.51.51,0,0,1-.267.815Z",
    transform: "translate(-187.802 -142.378)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M185.143,100.122c.058.28.251.476.418.418a.492.492,0,0,0,.23-.576c-.054-.28-.255-.476-.418-.418A.478.478,0,0,0,185.143,100.122Z",
    transform: "translate(-154.789 -92.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M185.71,102.09a10.251,10.251,0,0,0,1.825,2.126,1.658,1.658,0,0,1-1.287.522Z",
    transform: "translate(-155.13 -93.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M181.776,96.527a.18.18,0,0,1-.113-.046.171.171,0,0,1,0-.238,1.671,1.671,0,0,1,1.429-.556.171.171,0,0,1-.054.334h0a1.333,1.333,0,0,0-1.128.451A.163.163,0,0,1,181.776,96.527Z",
    transform: "translate(-152.746 -90.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M165.678,112.79c.485,2.465.773,5.877-.948,7.519,0,0,.673,2.506,5.251,2.506,5.038,0,2.423-2.2,2.423-2.2-2.089-.647-2.089-3.033-1.6-4.946Z",
    transform: "translate(-142.914 -100.046)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M162.656,130.232c-.418-.66-.28-2.661.221-2.987.8-.526,4.11-.468,8.5.815a3.144,3.144,0,0,0,.372,2.991Z",
    transform: "translate(-141.562 -108.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M151.573,143.32c-1.566,1.546-2.022,4.712-1.85,6.871.384-.656.794-1.312,1.216-1.951.631-.982,1.3-1.938,1.98-2.9.188-.263.38-.531.576-.8.038-.171.071-.343.1-.51Z",
    transform: "translate(-134.156 -117.823)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M126.405,406.006a1.1,1.1,0,0,0,.835-.046.326.326,0,0,0,.079-.372.376.376,0,0,0-.2-.234c-.455-.217-1.5.209-1.546.226a.08.08,0,0,0,0,.146A4.182,4.182,0,0,0,126.405,406.006Zm.551-.539.092.029a.217.217,0,0,1,.121.138c.042.142,0,.188-.029.2-.18.155-.835,0-1.324-.18a2.6,2.6,0,0,1,1.157-.2Z",
    transform: "translate(-120.083 -270.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M125.585,404.431h.038c.384-.109,1.2-.689,1.207-1.069a.259.259,0,0,0-.2-.259.418.418,0,0,0-.355.029c-.447.23-.731,1.161-.744,1.2a.062.062,0,0,0,.058.1Zm.952-1.195h.038c.1.033.1.084.1.1,0,.226-.543.677-.94.861a1.934,1.934,0,0,1,.614-.944.267.267,0,0,1,.209-.021Z",
    transform: "translate(-120.081 -269.076)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M185.667,407.189a1.381,1.381,0,0,0,.99-.255.3.3,0,0,0,0-.347.418.418,0,0,0-.255-.188c-.56-.15-1.738.518-1.788.547a.075.075,0,0,0-.038.084.079.079,0,0,0,.063.067A6.039,6.039,0,0,0,185.667,407.189Zm.535-.652a.6.6,0,0,1,.155,0,.234.234,0,0,1,.155.113c.058.1.038.146,0,.175-.155.217-1.007.221-1.633.134A3.639,3.639,0,0,1,186.2,406.537Z",
    transform: "translate(-154.47 -270.998)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M184.639,405.983h.033c.418-.18,1.211-.911,1.153-1.291,0-.092-.079-.2-.3-.226a.605.605,0,0,0-.443.138,2.37,2.37,0,0,0-.526,1.3.088.088,0,0,0,.033.071A.08.08,0,0,0,184.639,405.983Zm.835-1.366h.05c.142,0,.15.071.155.088.038.23-.51.8-.923,1.048a1.863,1.863,0,0,1,.443-1.036.418.418,0,0,1,.263-.1Z",
    transform: "translate(-154.461 -269.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M175.89,397.033h3.367l.334-7.8h-3.367Z",
    transform: "translate(-149.412 -261.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M116.83,394.055l3.25.689,2.949-7.465-3.25-.689Z",
    transform: "translate(-115.023 -259.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M117.861,403.963l-3.7-.8a.292.292,0,0,0-.326.163l-1.287,2.786a.5.5,0,0,0,.355.693c1.3.255,1.942.317,3.567.668,1,.217,3.262.769,4.645,1.065s1.855-1.028,1.316-1.274a9.468,9.468,0,0,1-4.081-2.982A.81.81,0,0,0,117.861,403.963Z",
    transform: "translate(-112.503 -269.121)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M177.426,407h-3.68a.3.3,0,0,0-.288.23l-.664,2.995a.493.493,0,0,0,.485.6c1.328-.025,3.246-.1,4.912-.1,1.951,0,2.644.1,4.929.1,1.383,0,1.767-1.4,1.191-1.525-2.636-.576-3.8-.639-6.074-2.043A1.583,1.583,0,0,0,177.426,407Z",
    transform: "translate(-147.602 -271.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M179.812,389.24l-.171,4.018H176.27l.171-4.018Z",
    transform: "translate(-149.634 -261.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M121.77,386.59l3.25.689-1.52,3.847-3.25-.685Z",
    transform: "translate(-117.014 -259.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M144.592,202.75s-3.826,25.748-5.923,35.393c-2.3,10.564-14.62,45.531-14.62,45.531L118,282.346s8.622-28.48,10.547-43.246c1.483-11.341,4.4-36.341,4.4-36.341Z",
    transform: "translate(-115.704 -152.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M144.592,202.75s-3.826,25.748-5.923,35.393c-2.3,10.564-14.62,45.531-14.62,45.531L118,282.346s8.622-28.48,10.547-43.246c1.483-11.341,4.4-36.341,4.4-36.341Z",
    transform: "translate(-115.704 -152.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M124.907,389.758c.025,0-1.124,2.18-1.124,2.18L117,390.468l.572-2.038Z",
    transform: "translate(-115.122 -260.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M170.638,224.662c-4.419.869-3.952,17.356-3.421,25.836,1.253-5.994,3.141-17.544,4.419-25.715A1.541,1.541,0,0,0,170.638,224.662Z",
    transform: "translate(-144.169 -165.168)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M180.446,202.75s.464,25.188.1,35.464c-.38,10.685-4.11,45.677-4.11,45.677H170.7s-.209-34.365-.464-44.863c-.276-11.441-1.671-36.279-1.671-36.279Z",
    transform: "translate(-145.15 -152.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M180.446,202.75s.464,25.188.1,35.464c-.38,10.685-4.11,45.677-4.11,45.677H170.7s-.209-34.365-.464-44.863c-.276-11.441-1.671-36.279-1.671-36.279Z",
    transform: "translate(-145.15 -152.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M179.595,391.56c.025,0-.326,2.368-.326,2.368h-6.951l-.188-2.114Z",
    transform: "translate(-147.223 -262.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M170.832,134.787c.689,3.642,1.967,13.818-.029,28.622l-19.5-.3c-.113-2.586,1.942-16.621.042-29.081a2.69,2.69,0,0,1,2.31-3.066c.986-.134,2.13-.259,3.258-.313a66.831,66.831,0,0,1,7.657,0c.835.079,1.671.2,2.414.33A4.77,4.77,0,0,1,170.832,134.787Z",
    transform: "translate(-135.093 -110.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M194.734,149.37l-3.283.815c-.251,3.066,1.771,6.537,3.793,9.19a87.88,87.88,0,0,0-.51-10Z",
    transform: "translate(-158.461 -121.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M189.786,136.79c.556,1,1.157,2.089,1.775,3.1s1.253,2.055,1.892,3.058a40.841,40.841,0,0,0,4.177,5.564c.192.2.38.4.572.581l.142.138.113.1c.063.067.171.142.251.213a14.393,14.393,0,0,0,1.333.923c.982.606,2.034,1.2,3.1,1.771,2.139,1.149,4.353,2.277,6.537,3.417l-.865,2.377a63.127,63.127,0,0,1-7.289-2.218c-1.195-.447-2.393-.932-3.592-1.52a16.962,16.962,0,0,1-1.85-1.028c-.163-.117-.317-.209-.493-.347l-.251-.192-.2-.171c-.28-.226-.535-.459-.794-.693a28.93,28.93,0,0,1-2.757-2.957c-.835-1.015-1.617-2.089-2.356-3.129s-1.441-2.143-2.089-3.25-1.291-2.193-1.892-3.4Z",
    transform: "translate(-154.862 -114.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M162.24,95.558c.911,3.4,1.253,5.43,3.371,6.851a4.673,4.673,0,0,0,7.21-3.918c.109-3.241-1.4-8.258-5.046-8.943a4.8,4.8,0,0,0-5.535,6.011Z",
    transform: "translate(-141.36 -86.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M165.182,91.421c.81-1.19,1.119-3.02.551-3.9.531.221,4.357.485,2.857-2.239a6,6,0,0,0-7.126-2.724l1.274.368s-3.58-.259-5.322,1.19a9.374,9.374,0,0,0,.99,0s-3.835,1.809-2.164,3.183c-2.694,2.051-.869,4.891,3.567,9.127.773.7,2.962.443,3.446.025C162.947,94.6,164.727,92.1,165.182,91.421Z",
    transform: "translate(-137.238 -82.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M179.1,98.61a11.505,11.505,0,0,1,2.231,3.141c.455.852.936.744,1.165,1.082s1.17,6.061.163,6.976-4.035-.531-4.432-1.583.33-3.634.526-4.223a6.011,6.011,0,0,0-.175-3.058A3.259,3.259,0,0,1,179.1,98.61Z",
    transform: "translate(-150.705 -91.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M176.092,102.01A3.216,3.216,0,0,0,177.617,104c.923.418,1.036-.656.856-1.671a2.458,2.458,0,0,0-1.165-2.03C176.427,99.842,175.788,101,176.092,102.01Z",
    transform: "translate(-149.485 -92.713)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsors);
export default __webpack_public_path__ + "static/media/sponsors.ca268958.svg";
export { ForwardRef as ReactComponent };